import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import actions from '@src/redux/actions';
import { StyledNewReferralBanner } from './index.style';

const NewReferralBanner = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleOpenOnboardingPopupMobile = () => {
    dispatch(actions.layout.setShowOnboardingPopupMobile(true));
  };

  return (
    <StyledNewReferralBanner
      useVoucherByProduct
      onClick={handleOpenOnboardingPopupMobile}
    >
      <span
        style={{
          fontWeight: 760,
          fontSize: '16px',
          color: '#1C1C1E',
          letterSpacing: '-0.4px',
          lineHeight: '20px',
          marginLeft: '16px',
          fontFamily: 'SF Pro !important',
        }}
      >
        {t('get500kCharacters')}
      </span>
    </StyledNewReferralBanner>
  );
};

export default NewReferralBanner;
